import { Injectable } from '@angular/core';
import { IPaymentRequestApiClient } from './i-payment-request.api.client';
import { ApiClientProvider } from '../../../common';
import { PaymentRequestApiClient } from './payment-request-.api.client';
import { PaymentRequestInMemoryApiClient } from './payment.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class PaymentRequestApiClientProvider extends ApiClientProvider<IPaymentRequestApiClient> {
  constructor(
    private client: PaymentRequestApiClient,
    private inMemoryClient: PaymentRequestInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IPaymentRequestApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IPaymentRequestApiClient {
    return this.client;
  }
}